import { render, staticRenderFns } from "./Korean.vue?vue&type=template&id=a44fbf7a&scoped=true"
import script from "./Korean.vue?vue&type=script&lang=js"
export * from "./Korean.vue?vue&type=script&lang=js"
import style0 from "./Korean.vue?vue&type=style&index=0&id=a44fbf7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44fbf7a",
  null
  
)

export default component.exports